import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { orgActions, ingestionActions } from "../../actions";
import { IngestorNav } from "./IngestorNav";
import { Link } from "react-router-dom";

function RenderRequest(props) {
  const [submitted, setSubmitted] = useState(false);
  const [ingestionRequest, setIngestionRequest] = useState({ limit: -1 });

  const { authentication, org, getScrapeInfo, render } = props;

  const user_orgs = authentication.user.orgs;
  const current_org_id = Number(org.current_org_id);
  const current_org_name = user_orgs.filter(
    (org) => org.org_id === current_org_id
  )[0].display_name

  const scrape_info = org.scrape_info;

  const unrendered_file_count =
    scrape_info?.s3_file_count - scrape_info?.db_file_count;

  useEffect(() => {
    getScrapeInfo(current_org_id);
  }, [current_org_id]);

  const setScrapeLimit = (e) => {
    const { value } = e.target;
    ingestionRequest["limit"] = Number(value);
    console.log(ingestionRequest);
  };

  const submitRequest = (e) => {
    e.preventDefault();
    ingestionRequest["org_id"] = current_org_id;
    ingestionRequest["org_name"] = current_org_name;
    ingestionRequest["ingestion_type"] = "render";
    console.log(ingestionRequest);
    render(ingestionRequest);
    setSubmitted(true);
  };

  return (
    <>
      {submitted && (
        <>
          <div class="refresh" />
          <div class="searchMain">
            <div class="contentContainerLeftNav">
              <div class="leftNav">
                <IngestorNav />
              </div>
              <div class="rightContent">
                <form class="ingestorForm">
                  <table class="ingestorFormTable">
                    <tr>
                      <td class="formLabel">&nbsp;</td>
                      <td class="formInfo">
                        <strong>Render request initiated:</strong>
                      </td>
                    </tr>
                    <tr>
                      <td class="formLabel">Org:</td>
                      <td class="formInfo">{ingestionRequest.org_name}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">File Limit:</td>
                      <td class="formInfo">{ingestionRequest.limit}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">&nbsp;</td>
                      <td class="formInfo">
                        <Link to={"/org/" + current_org_id + "/ingestion"}>
                          go back
                        </Link>
                      </td>
                    </tr>
                  </table>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {!submitted && (
        <>
          <div class="refresh" />
          <div class="searchMain">
            <div class="contentContainerLeftNav">
              <div class="leftNav">
                <IngestorNav parent="render" />
              </div>
              <div class="rightContent">
                <form class="ingestorForm">
                  <table class="ingestorFormTable">
                    <tr>
                      <td class="formLabel">Org:</td>
                      <td class="formInfo">{current_org_name}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">S3 file count:</td>
                      <td class="formInfo">{scrape_info?.s3_file_count}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">Rendered file count:</td>
                      <td class="formInfo">{scrape_info?.db_file_count}</td>
                    </tr>
                    {unrendered_file_count > 0 && (
                      <>
                        <tr>
                          <td>&nbsp;</td>
                          <td class="errormessage formInfo">
                            There are {unrendered_file_count} unrendered files
                            in s3.
                          </td>
                        </tr>
                        <tr colspan="2">
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <hr />
                          </td>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td class="formInfo">Initiate a Rendering Run:</td>
                        </tr>
                        <tr>
                          <td class="formLabel">
                            <label for="limit">Limit:</label>
                          </td>
                          <td class="formInfo">
                            <input
                              type="text"
                              name="limit"
                              id="limit"
                              onChange={setScrapeLimit}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td class="formLabel">&nbsp;</td>
                          <td class="formInfo">
                            <button class="submit" onClick={submitRequest}>
                              Submit
                            </button>
                          </td>
                        </tr>
                      </>
                    )}
                  </table>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getScrapeInfo: orgActions.getScrapeInfo,
  render: ingestionActions.render,
};

const connectedRenderRequest = connect(
  mapStateToProps,
  actionCreators
)(RenderRequest);
export { connectedRenderRequest as RenderRequest };
